<template>
  <q-page padding>
    <div class="row col-12 align">
      <p class="text-h6 text-brand-1 text-weight-bold">
        Receber Produtos do Pedido: {{ dados.id }}
        <q-icon
          name="print"
          class="cursor"
          @click="imprimir"
          color="primary"
          size="24px"
        />
      </p>
    </div>

    <div class="q-mt-lg">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        class="tabela-tamanho-fixo"
        dense
        title-class="text-brand-5 text-weight-bold"
        hide-pagination
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >{{ title }}</span
          >
        </template>
        <template #body-cell-selecionar="props">
          <q-td>
            <q-checkbox
              :disable="
                rows3.find((e) => {
                  return e.id == props.row.id;
                })
              "
              v-model="selecionados"
              :val="props.row"
            />
          </q-td>
        </template>
      </q-table>
    </div>

    <section
      v-if="status == 'Enviado' || status == 'Recebido_parcialmente'"
      class="row justify-between q-mt-lg"
    >
      <q-btn
        icon="close"
        label="Fechar Pedido Inteiro"
        no-caps
        style="background-color: #21324a; border-radius: 8px; color: white"
        @click="confirmarFecharInteiro"
      />
      <q-btn
        label="Fechar Pedido Parcialmente"
        color="positive"
        no-caps
        icon="done"
        style="border-radius: 8px; color: white"
        @click="confirmarFecharParcialmente"
        :disable="selecionados.length == 0"
      />
    </section>

    <div
      v-if="status == 'Enviado' || status == 'Recebido_parcialmente'"
      class="q-pa-md q-mt-xl q-mb-md"
    >
      <section class="row justify-between q-mt-lg">
        <q-btn
          class="row justify-end q-mt-sm"
          label="Historico de Fechamento"
          color="secondary"
          no-caps
          style="border-radius: 8px; color: white"
          @click="abrirDivergencia"
          @resultado="setModalFechar"
        />
        <q-btn
          v-if="status == 'Enviado' || status == 'Recebido_parcialmente'"
          label="Recebimento por NF"
          color="positive"
          no-caps
          style="border-radius: 8px; color: white"
          @click="rightDrawerOpen = !rightDrawerOpen"
        />
      </section>
    </div>

    <q-table
      v-if="
        (rows3.length != 0 && status == 'Enviado') ||
        status == 'Recebido_parcialmente' ||
        status == 'Recebido'
      "
      class="q-mt-xl tabela-tamanho-fixo"
      flat
      table-header-class="bg-accent text-width-bold"
      title-class="text-brand-5 text-weight-bold"
      :rows="rows3"
      dense
      :columns="columns3"
      :loading="disable"
      hide-pagination
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      @request="handleRequest"
    >
      <template v-slot:top-left>
        <span
          style="
            font-size: 16px;
            display: block;
            margin-left: -15px;
            color: #21324a;
          "
          >Recebimentos deste Pedido</span
        >
      </template>
      <template #body-cell-code="props">
        <q-td>
          <div
            @click="verNota(props.row?.pivot?.nf_id)"
            style="cursor: pointer"
            class="text-info"
          >
            {{ props.row?.pivot?.nf_numero }}
          </div>
        </q-td>
      </template>
    </q-table>
    <dialog-info-design
      mensagem="Confirma o recebimento dos produtos?"
      subMensagem="Tem certeza que deseja fechar os produtos selecionados?. Essa ação é irreversivel."
      :exibir="confirmDialog"
      :showCancelar="true"
      @resultado="receberTodos"
    >
    </dialog-info-design>
    <DialogConfirmDesign
      :exibir="modalFecharInteiro"
      mensagem="Tem certeza que deseja fechar este pedido?"
      @resultado="handleFecharInteiroConfirmacao"
    />
    <DialogConfirmDesign
      :exibir="modalFecharParcialmente"
      mensagem="Tem certeza que deseja fechar este pedido?"
      @resultado="handleFecharParcialmenteConfirmacao"
    />
    <DialogConfirmDesign
      :exibir="modalReceberProdutos"
      mensagem="Tem certeza que deseja receber esses itens?"
      @resultado="handleReceberProdutosConfirmacao"
    />
    <dialog-info-design
      mensagem="Historico de Fechamento"
      :showConteudo="true"
      :exibir="confirmDialogDivergencia"
      :showCancelar="true"
      :desabilitarConfirme="true"
      :width="'auto'"
      :esconderConfirme="true"
      @resultado="setModalFechar"
    >
      <q-table
        class="tabela-tamanho-fixo"
        flat
        table-header-class="bg-accent text-width-bold"
        title-class="text-brand-5 text-weight-bold"
        :rows="rows4"
        dense
        :columns="columns4"
        :loading="disable"
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
      </q-table>
    </dialog-info-design>
    <ModalInformacaoesAdicionais
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="'Recebimento por NF'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Número da Nota Fiscal</div>

          <q-input
            outlined
            dense
            v-model="numeroNota"
            placeholder="Número da NF"
            class="input-new-design"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          >
          </q-input>
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Serie da Nota Fiscal</div>

          <q-input
            class="input-new-design"
            v-model="serieNota"
            outlined
            dense
            placeholder="Série da NF"
          >
          </q-input>
        </div>

        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Data de Emissão</div>
          <q-input
            dense
            outlined
            class="input-new-design"
            placeholder="Data de Emissão"
            v-model="data"
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date :locale="myLocale" mask="DD/MM/YYYY" v-model="data">
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <span style="margin-top: 8px; display: flex">Produtos</span>
        <section
          style="height: 318px; overflow-y: scroll"
          class="column no-wrap"
        >
          <div v-for="(value, index) in rows" :key="index">
            <span
              style="align-items: center; flex-wrap: nowrap"
              v-if="
                Number(
                  value.pivot.amount - value.pivot.amount_received
                ).toFixed(2) != 0.0
              "
              class="row q-mt-sm"
            >
              <span><q-checkbox v-model="selecionados" :val="value" /></span>
              <span
                style="
                  max-width: 70px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  flex-wrap: nowrap;
                  max-height: 40px;
                "
                class="q-mr-sm"
                >{{ value.name }}
                <q-tooltip
                  class="bg-brand-1 text-body2"
                  anchor="top middle"
                  self="bottom middle"
                  :offset="[10, 10]"
                  >{{ value.name }}</q-tooltip
                ></span
              >

              <div style="max-width: 80px" class="q-mr-sm">
                <q-input
                  dense
                  outlined
                  label="Preço"
                  v-model="value.pivot.price"
                >
                  <q-tooltip
                    class="bg-brand-1 text-body2"
                    anchor="top middle"
                    self="bottom middle"
                    :offset="[10, 10]"
                    >{{ value.pivot.price }}</q-tooltip
                  >
                </q-input>
              </div>

              <div style="max-width: 80px" class="q-mr-sm">
                <q-input
                  dense
                  outlined
                  label="Quantidade"
                  v-model="value.pivot.amount"
                >
                  <q-tooltip
                    class="bg-brand-1 text-body2"
                    anchor="top middle"
                    self="bottom middle"
                    :offset="[10, 10]"
                    >{{ value.pivot.amount }}</q-tooltip
                  >
                </q-input>
              </div>

              <div style="max-width: 110px" class="q-mr-sm">
                <q-input
                  dense
                  outlined
                  placeholder="DD/MM/AAAA"
                  v-model="valuedate_receipt"
                  mask="##/##/####"
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        cover
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          :locale="myLocale"
                          mask="DD/MM/YYYY"
                          v-model="value.date_receipt"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Fechar"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                  <q-tooltip
                    class="bg-brand-1 text-body2"
                    anchor="top middle"
                    self="bottom middle"
                    :offset="[10, 10]"
                    >{{ value.date_receipt }}</q-tooltip
                  >
                </q-input>
              </div>
            </span>
          </div>
        </section>
      </template>
      <template v-slot:botao-modal>
        <div class="row col-12 q-gutter-sm">
          <q-btn
            no-caps
            label="Receber Produtos"
            class="btn-modal"
            icon="add"
            @click="confirmarReceberProdutos"
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              font-weight: normal;
            "
          />
        </div>
      </template>
    </ModalInformacaoesAdicionais>
  </q-page>
</template>

<script>
// funçao para formatar quantidade (minimo 2 casas decimais, maximo 4)
const formatQuantidade = (value) => {
  if (!value && value !== 0) return "0,00";
  const num = Number(value);
  if (isNaN(num)) return "0,00";
  
  let formatted = num.toFixed(4);
  
  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return formatted.replace('.', ',');
};

// funçao para formatar preço (R$ com minimo 2 casas decimais, maximo 4)
const formatPreco = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  const num = Number(value);
  if (isNaN(num)) return "R$ 0,00";
  
  let formatted = num.toFixed(4);

  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return `R$ ${formatted.replace('.', ',')}`;
};

const columns = [
  {
    name: "selecionar",
    label: "Selecionar",
    field: "selecionar",
    align: "left",
  },
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "code",
    label: "Codigo",
    field: "code",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "name",
    label: "Descrição",
    field: "name",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "price",
    label: "Preço",
    field: (row) =>
      row.pivot.price
        ? formatPreco(row.pivot.price)
        : "Sem Preço",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "amount",
    label: "Comprado",
    field: (row) =>
      row.pivot.amount ? formatQuantidade(row.pivot.amount) : "0,00",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "recebimento",
    label: "Recebido",
    field: (row) =>
      row.pivot.amount_received
        ? formatQuantidade(row.pivot.amount_received)
        : "0,00",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "saldo",
    label: "Saldo",
    field: (row) =>
      formatQuantidade(row.pivot.amount - row.pivot.amount_received),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
];

const columns2 = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "code",
    label: "Codigo",
    field: "code",
    align: "left",
  },
  {
    name: "description",
    label: "Descrição",
    field: "description",
    align: "left",
  },
  {
    name: "price",
    label: "Preço",
    field: "price",
    align: "left",
  },
  {
    name: "amount",
    label: "Quantidade",
    field: "amount",
    align: "left",
  },
  {
    name: "data",
    label: "Data de Recebimento",
    field: "data",
    align: "left",
  },
];

const columns3 = [
  {
    name: "description",
    label: "Item",
    field: "description",
    align: "left",
  },
  {
    name: "code",
    label: "Nota Fiscal",
    field: "code",
    align: "left",
  },
  {
    name: "description",
    label: "Nota Fiscal Manual",
    field: "description",
    align: "left",
  },
  {
    name: "price",
    label: "Data Recebimento	",
    field: (row) =>
      row.pivot.date_receipt
        ? row.pivot.date_receipt.split("-").reverse().join("/")
        : "Sem data",
    align: "left",
  },
  {
    name: "amount",
    label: "Qtdade Recebida",
    field: (row) => (row.pivot.amount ? formatQuantidade(row.pivot.amount) : "0,00"),
    align: "left",
  },
];

const columns4 = [
  {
    name: "codigo",
    label: "Codigo",
    field: "codigo",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: "descricao",
    align: "left",
  },
  {
    name: "qtd_original",
    label: "Quantidade Original",
    field: "qtd_original",
    align: "left",
  },
  {
    name: "qtd_fechamento",
    label: "Quantidade Alterada",
    field: "qtd_fechamento",
    align: "left",
  },
  {
    name: "Nome_Responsavel",
    label: "Nome Responsável",
    field: "Nome_Responsavel",
    align: "left",
  },
  {
    name: "Nome_Matricula",
    label: "Matricula Responsável",
    field: "Nome_Matricula",
    align: "left",
  },
];

import { ref, onMounted, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";
import ModalInformacaoesAdicionais from "../components//ModalInformacaoesAdicionais.vue";
export default {
  components: { DialogInfoDesign, DialogConfirmDesign, ModalInformacaoesAdicionais },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const rows = ref([]);
    const rows2 = ref([]);
    const rows3 = ref([]);
    const $q = useQuasar();
    const rightDrawerOpen = ref(false);
    const confirmDialog = ref(false);
    const confirmDialogDivergencia = ref(false);
    const modalFecharInteiro = ref(false);
    const modalFecharParcialmente = ref(false);
    const modalReceberProdutos = ref(false);
    const selecionados = ref([]);
    const title = ref("");
    const disable = ref(true);
    const produtos = ref([]);
    const status = ref("");
    const id = route.params.id;
    const serieNota = ref("");
    const numeroNota = ref("");
    const data = ref("");
    const rows4 = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const dados = ref("");

    const getDados = async () => {
      try {
        const response = await store.dispatch("compras/pedidoEspecifico", {
          id: id,
        });

        dados.value = response.data.message;
        rows.value = response.data.message.products;
        rows3.value = response.data.message.received;
        status.value = response.data.message.status;

        title.value = `Pedido: ${
          response.data?.message?.provider?.business_name
        } | ${
          response.data?.message?.vendor?.name
        } - Criado em: ${response?.data?.message?.created_at
          .split(" ")[0]
          .split("-")
          .reverse()
          .join("/")} | Status: ${response?.data?.message?.status}`;

        disable.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    onMounted(getDados);

    const confirmarFecharInteiro = () => {
      modalFecharInteiro.value = true;
    };

    const handleFecharInteiroConfirmacao = async (confirmado) => {
      modalFecharInteiro.value = false;
      if (confirmado) {
        await fechar();
      }
    };

    const confirmarFecharParcialmente = () => {
      modalFecharParcialmente.value = true;
    };

    const handleFecharParcialmenteConfirmacao = async (confirmado) => {
      modalFecharParcialmente.value = false;
      if (confirmado) {
        await receberTodos(true);
      }
    };

    const confirmarReceberProdutos = () => {
      modalReceberProdutos.value = true;
    };

    const handleReceberProdutosConfirmacao = async (confirmado) => {
      modalReceberProdutos.value = false;
      if (confirmado) {
        await receber();
      }
    };

    const fechar = async () => {
      try {
        await store.dispatch("compras/fecharPedido", {
          purchase_id: id,
        });

        $q.notify({
          message: "Pedido fechado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao fechar pedido",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const abrirDivergencia = async () => {
      confirmDialogDivergencia.value = !confirmDialogDivergencia.value;

      const divergencia = JSON.parse(dados.value.divergencia);

      rows4.value = divergencia.produtos.map((value) => {
        return {
          ...value,
          Nome_Responsavel: divergencia.usuario_logado.nome,
          Nome_Matricula: divergencia.usuario_logado.matricula,
        };
      });
    };

    const setModalFechar = async (value) => {
      confirmDialogDivergencia.value = value;
    };

    const receberTodos = async (resultado) => {
      if (resultado) {
        try {
          await store.dispatch("compras/receberComDiferenca", {
            purchase_id: id,
            produtos: selecionados.value.map((value) => ({
              uuid: value.pivot.uuid,
            })),
          });

          $q.notify({
            message: "Pedido fechado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getDados();
        } catch (error) {
          $q.notify({
            message: "Erro ao fechar pedido",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const receber = async () => {
      let products = [];
      rows2.value.forEach((e) => {
        products.push({
          amount: e.pivot.amount,
          date_receipt: e.date_receipt,
          id: e.id,
          price: e.pivot.price,
          uuid_produto_pedido: e.pivot.uuid,
          dados_nf: {
            data_emissao: data.value,
            numero: numeroNota.value,
            serie: serieNota.value,
          },
        });
      });

      try {
        await store.dispatch("compras/receberProdutos", {
          purchase_id: id,
          products: products,
        });

        $q.notify({
          message: "Pedido recebido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao receber pedido",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verNota = async (id) => {
      const routeData = router.resolve({
        name: "nf-editar",
        params: { notaId: id },
      });
      window.open(routeData.href, "_blank");
    };

    const imprimir = async () => {
      router.push({
        name: "compras-imprimir-pedidos",
        params: { id: dados.value.id },
      });
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => selecionados.value,
      () => {
        rows2.value = selecionados.value;
      }
    );

    return {
      dados,
      getDados,
      produtos,
      imprimir,
      columns,
      rows,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      handleRequest,
      selecionados,
      title,
      rows2,
      columns2,
      fechar,
      receberTodos,
      status,
      confirmDialog,
      rightDrawerOpen,
      columns4,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      receber,
      data,
      serieNota,
      numeroNota,
      rows3,
      columns3,
      verNota,
      confirmDialogDivergencia,
      abrirDivergencia,
      setModalFechar,
      rows4,
      formatQuantidade,
      formatPreco,
      modalFecharInteiro,
      modalFecharParcialmente,
      confirmarFecharInteiro,
      confirmarFecharParcialmente,
      handleFecharInteiroConfirmacao,
      handleFecharParcialmenteConfirmacao,
      modalReceberProdutos,
      confirmarReceberProdutos,
      handleReceberProdutosConfirmacao,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}

.cursor {
  cursor: pointer;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
